import { TableCell } from "@mui/material";
import TableHeader from "@crema/core/AppTable/TableHeader";

const TableHeading = () => {
  return (
    <TableHeader>
      <TableCell align="left">Order Id</TableCell>
      <TableCell align="left">Txn ID</TableCell>
      <TableCell align="left">Txn Date</TableCell>
      <TableCell align="left">Cust ID</TableCell>
      <TableCell align="left">Name</TableCell>
      <TableCell align="left">RMN</TableCell> 
      <TableCell align="left">Type</TableCell>
      <TableCell align="left">Res Msg</TableCell>
      <TableCell align="left">Wallet</TableCell>
      <TableCell align="left">RefNo</TableCell>
      <TableCell align="center">Amount</TableCell>
      <TableCell align="center">Status</TableCell>
    </TableHeader>
  );
};

export default TableHeading;
